import React, { Component } from "react";
import { AppContext } from "../utils/context";
import { request as xhr, queryString } from "../utils/request";
import { blankImage } from "../utils/constants";
import Alert from "../components/Alert";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Button from "../components/Button";

class PrintDiscountCodeSuper extends Component {
    render() {
        const { localLanguage } = this.context;

        return (
            <div className={`container mx-auto py-6`}>
                <div className="max-w-xs rounded overflow-hidden mb-6 m-auto text-center">
                    <ReactToPrint content={() => this.componentRef}>
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <Button onClick={handlePrint} content={localLanguage.general_print_discount_code_title} />
                            )}
                        </PrintContextConsumer>
                    </ReactToPrint>
                </div>
                <PrintDiscountCode {...this.props} ref={el => (this.componentRef = el)} />
            </div>
        );
    }
}
PrintDiscountCodeSuper.contextType = AppContext;

class PrintDiscountCode extends Component {
    state = {
        discountCode: false,
        errMessage: '',
        text: '',
        img: '',
        ticketInfo: false
    }

    componentDidMount = async () => {
        const { settings } = this.context;
        let qs = queryString.parse(this.props.location.search);
        let orderId = qs.orderId ? qs.orderId : qs.orderid;
        let hash = qs.hash ? qs.hash : (qs.orderhash ? qs.orderhash : '');
        xhr.get(`api:/web/order/${orderId}/discount-code`, { 'hash': hash }).then(data => {
            if (data.status === 'error') {
                this.setState({ errMessage: data.error });
            } else {
                this.setState({ discountCode: data.discountCodes });
                this.setState({ img: data.imageUrl ?? null });
                this.setState({ text: data.text ?? null });
            }
        });
        if (settings.show_ticket_number_in_discount_code_page) {
            xhr.get(`api:/web/order/${orderId}/tickets`, { 'hash': hash }).then(data => {
                this.getTicketInfo(data);
            });
        }
    }
    
    getTicketInfo = (data) => {
        let ticketInfo = {};
        data.tickets.forEach(ticket => {
            ticketInfo[ticket.id] = ticket;
            ticketInfo[ticket.id]["event"] = data.events[ticket.event_id];
            ticketInfo[ticket.id]["nonProfit"] = data.nonProfits[ticket.nonprofit_id];
        });
        this.setState({ ticketInfo: ticketInfo, data });
    }

    render() {
        const { discountCode, errMessage, img, text, ticketInfo } = this.state;
        const { localLanguage } = this.context;

        return (
            <div className={`container mx-auto py-6`}>
                {img && (
                    <div className="text-center mb-4">
                        <img src={img} alt={localLanguage.general_logo} onError={(e) => { e.target.src = blankImage }} className="block mx-auto" />
                    </div>
                )}
                {text && (
                    <div className="text-center mb-4">
                        <h1 className="text-2xl font-bold">{text}</h1>
                    </div>
                )}
                
                {discountCode && (
                    <div>
                         <div className="text-center mb-4">
                            <h2 className="text-xl font-bold"></h2>
                        </div> 
                        {Object.values(discountCode).map((codeGroup, index) => (
                            <div key={index} className="border-2 border-gray-300 rounded-lg mb-6">
                                <div className="text-center mb-2">
                                    <p className="text-lg font-bold">{codeGroup.description}</p>
                                </div>
                                <div className="text-center">
                                    {codeGroup.codes.map((codeObj, idx) => (
                                        <div key={idx} className="mb-2">
                                            <span className="text-xl font-bold">{codeObj.code}</span>
                                            {codeObj.barcode && (
                                                <div>
                                                    <img src={`data:image/png;base64,${codeObj.barcode}`} alt={`Barcode for ${codeObj.code}`} />
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <div className={`container mx-auto py-6`}>
                    {ticketInfo && (
                        <div>
                            <div className="text-center mb-4">
                                <h2 className="text-xl font-bold">{localLanguage.order_info_et_reference_number}</h2>
                            </div>
                            {Object.values(ticketInfo).map((ticket, index) => (
                                <div key={index} className="px-6 py-4 text-xl border-2 border-gray-300 rounded-lg mb-4">
                                    {ticket.event !== null && (
                                        <p className="mb-4 font-bold text-center">{ticket.event.title}</p>
                                    )}
                            
                                    <div className="px-6 py-4">
                                        {ticket.show_first_last_number ? (
                                            ticket.numbers.length === 1 ? (
                                                <div>
                                                    <div className="font-bold text-xl text-center mb-2">
                                                        {ticket.numbers[0]}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="text-md text-center mb-2">
                                                        {localLanguage.first_last_number_verbiage}
                                                    </div>
                                                    <div className="font-bold text-xl text-center mb-2">
                                                        {ticket.numbers[0]}
                                                    </div>
                                                    <div className="text-md text-center mb-2">
                                                        {localLanguage.to_text}
                                                    </div>
                                                    <div className="font-bold text-xl text-center mb-2">
                                                        {ticket.numbers[ticket.numbers.length - 1]}
                                                    </div>
                                                </div>
                                            )
                                        ) : (
                                            ticket.numbers.reduce((rows, num, index) => {
                                                if (index % 2 === 0) rows.push([]);
                                                rows[rows.length - 1].push(num);
                                                return rows;
                                            }, []).map((row, rowIndex) => (
                                                <div key={rowIndex} className="flex justify-center gap-4 mb-2">
                                                    {row.map(num => (
                                                        <div key={num} className="font-bold text-xl text-center px-4">{num}</div>
                                                    ))}
                                                </div>
                                            ))
                                        )}
                                        {ticket.number_Model === 'single_number_multi_chance' && (
                                            <div className="font-bold text-lg text-center mb-1">
                                                <div className="flex-1">{`${localLanguage.general_chances_to_win.charAt(0).toUpperCase() + localLanguage.general_chances_to_win.slice(1)} ${ticket.quantity}`}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {(errMessage && !discountCode) && (
                    <div className="flex flex-wrap mb-6">
                        <div className="w-full md:w-1/2">
                            <Alert
                                visible={false}
                                error={errMessage}
                                success={false}
                                message={errMessage}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
PrintDiscountCode.contextType = AppContext;

export default PrintDiscountCodeSuper;